<template>
    <div v-if="asyncDataStatus_ready">

    <v-row justify="space-between">
      <v-col cols="6">
        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              v-if="this.distributors.length"
              placeholder="Išči (ime ali davčna)..."
              append-icon="mdi-search"
              v-model="filter"
              @keydown.esc="filter=''"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-checkbox
              color="#0F998E"
              v-model="activeOnly"
              label="Samo aktivni"
            ></v-checkbox>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="auto">
        <v-btn
          color="#0F998E"
          class="white--text"
          @click="$router.push({name: 'ClientsNew', params: { companyType: 2, companyTypeName: 'Distributors' }})"
        >
          Nov distributer
          <v-icon right dark>mdi-plus</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-row v-if="this.distributors.length">
      <v-col
        cols="12" md="6" xl="4"
        v-for="client of filteredDistributors" :key="client.id"
      >
        <ClientCard
          :client="client"
          @edit="$router.push({name: 'ClientsEdit', params: { id: client.id, companyTypeName: 'Distributors' }})"
          @details="$router.push({name: 'ClientsDetails', params: { id: client.id, companyTypeName: 'Distributors' }})"
          @identity="takeIdentity(client)"
        />
      </v-col>
    </v-row>
    <v-row
      v-else
    >
      <v-col cols="12">
        <p class="text-center">
          Ni rezultatov iskanja. Za dodajanje novega distributerja uporabite gumb desno zgoraj.
        </p>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { siIncludes } from '@/utils/str'
import asyncDataStatus from '@/mixins/asyncDataStatus'
import ClientCard from '@/components/ClientCard'

export default {
  mixins: [
    asyncDataStatus
  ],
  components: {
    ClientCard
  },
  data () {
    return {
      filter: '',
      activeOnly: true
    }
  },
  computed: {
    ...mapGetters('companies', ['distributors']),
    filteredDistributors () {
      return this.distributors.filter(client => (!this.activeOnly || client.is_active) && [client.name, client.tax_number].some(this.matchFilter))
    }
  },
  methods: {
    ...mapActions('companies', ['loadMyCompany', 'loadChildCompanies', 'takeCompanyIdentity']),
    deleteItem (item) {
      this.deleteClient({ id: item.id })
    },
    matchFilter (testString) {
      return siIncludes({ haystack: testString, needle: this.filter })
    },
    takeIdentity (item) {
      this.takeCompanyIdentity(item.id)
    }
  },
  created () {
    this.loadChildCompanies()
      .then(companies => {
        this.asyncDataStatus_fetched()
      })
  }
}
</script>
